import { Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function About() {
  return (
    <>
      <SEOHead
        title="About Us – All Yono Games Directory"
        description="Learn about All Yono Games, an independent game information and download directory for Indian players. We list Yono apps, rummy games, slot games, and Android APK downloads."
        keywords="About Yono Games, Game Directory, Yono Apps Information, Android Game Listings"
      />

      <Header />

      <main>
        <div className="px-4 py-6">
          <span className="inline-block px-2 py-0.5 bg-primary-100 text-primary-700 rounded-full text-[10px] font-semibold mb-2">
            Our Story
          </span>
          <h1 className="text-xl font-heading font-bold text-foreground-900 mb-4">
            About All Yono Games
          </h1>

          <div className="space-y-4 text-foreground-600 text-[13px] leading-relaxed">
            <p>
              All Yono Games is an independent game information and download directory created to help Indian players discover, compare, and access Yono gaming apps available for Android devices. We are passionate about gaming and committed to providing accurate, up-to-date information about every Yono game and app in the ecosystem.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Our Mission</h2>
            <p>
              Our mission is simple: make it easy for Indian gamers to find the right Yono apps for their preferences. With many gaming apps available, it can be overwhelming to know which ones are trustworthy and which provide the gaming experience you are looking for. We do the research so you do not have to.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">What We Offer</h2>
            <p>
              We provide detailed listings for each game including welcome bonuses, minimum deposits and withdrawals, platform requirements, features, and step-by-step download instructions. Every game page includes original, informative content to help you make an informed decision before downloading.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Important Disclaimer</h2>
            <p>
              All Yono Games is an independent informational directory. We are not the official owner, developer, or operator of any game listed on this website. All game names, logos, and trademarks belong to their respective owners. We provide information and download links for informational purposes only.
            </p>
            <p>
              We do not host any APK files on our servers. All download links direct users to external sources. Users should verify the authenticity of any app before installation and review all permissions requested by the application.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Our Commitment</h2>
            <p>
              We are committed to transparency, accuracy, and responsible gaming advocacy. Every page on our site includes responsible gaming reminders, and we maintain a dedicated Responsible Gaming page with guidance for players. This website is intended for users aged 18 and above.
            </p>
          </div>

          <div className="mt-8 text-center">
            <Link
              to="/games"
              className="inline-flex items-center gap-1.5 px-6 py-2.5 bg-primary-500 text-white rounded-full text-[13px] font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Browse All Games
              <i className="ri-arrow-right-line text-sm"></i>
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}